<template>
  <div class="book book-container" v-if="book"
  :style="`--sticker-random-top:${this.sticker.top}; --sticker-random-left:${this.sticker.left}`"
  :class="{'book-anthology': book.meta.Options.BookType == 'Anthology', 'book-largesize': book.meta.Options.LargeSize || $root.project == 'INTERCOM', 'book-extra': $root.extra}"
  >
    <Overlay :src.sync="overlaySource" :width="overlayWidth" :height="overlayHeight" :srcset="overlaySrcset" :caption="overlayCaption" :showNext="overlayShowNext"/>
    <div class="book-wrapper"  @click="closeTray">
      <Title
        v-bind:bookData="book"
        ref="titleComponent"
      />
      <div v-if="book.meta.Options.Preface" class="book-paper" style="padding-top: var(--padding-40);">
        <div class="book book-paper-content">
          <div class="book-text">
            <div class="page" v-html="book.meta.Options.Preface"/>
          </div>
        </div>
      </div>
      <Toc
        ref="tocComponent"
        :inline="true"
        :active="currentHead"
        :toc="book.toc"
        :hasParts="book.hasParts"
        :bibliography="book.meta.Bibliography"
        :acknowledgments="book.meta.Options.ThanksPostface"
        :acknowledgmentsToc="book.meta.Options.ThanksPostfaceToc"
        :images="book.images.length > 0"
        :imprint="book.meta.Options.Imprint"
        :index="book.index.length > 0"
        :citation="book.data.Citation"
        :doi="book.data.DoiLink"
        :meta="book.meta"
        :annexPDF="
        (book.data && book.data.AnnexPdfLink)
          ? book.data.AnnexPdfLink
          : ((book.data && book.data.AnnexPDF && book.data.AnnexPDF[0])
            ? book.data.AnnexPDF[0].Original
            : false)
        "
      />
      <div class="book-header" ref="header" :class="{'book-header-hidden': contentScrolled === false}">
        <div class="book-header-left">
          <a v-if="book.data && book.data.PdfLink" :href="book.data.PdfLink" target="_blank">&darr;&nbsp;{{$root.t('menu_pdf')}}</a>
          <a v-else-if="book.data && book.data.PDF && book.data.PDF[0]" target="_blank" :href="book.data.PDF[0].Original">&darr;&nbsp;{{$root.t('menu_pdf')}}</a>
          <a v-else class="inactive">&darr;&nbsp;{{$root.t('menu_pdf')}}</a>
          <a v-if="book.data && book.data.StoreLink" :href="book.data.StoreLink" target="_blank">↗&nbsp;{{$root.t('menu_buy')}}</a>
          <a v-else class="inactive">↗&nbsp;{{$root.t('menu_buy')}}</a>
        </div>
        <div class="book-header-center">
          <transition name="fade-fast">
            <a v-if="currentPageIndex !== false" :href="`#${book.pages[currentPageIndex]._id}`" class="book-header-current" v-html="book.pages[currentPageIndex].Title"></a>
            <div v-else/>
          </transition>
          <transition name="fade-fast">
            <div class="book-header-progress" v-html="progress"/>
          </transition>
        </div>
        <div class="book-header-right">
          <a @click="toTop">&uarr; <span>{{$root.t('menu_top')}}</span></a>
        </div>
      </div>
      <div class="book-paper" ref="pageContainer">
        <div class="book book-paper-content">
          <div
            class="book-text"
            :lang="$root.language == 0 ? 'de' : 'en'"
            :class="{'book-text-wide': chapter.Options.small === true, 'book-no-body': !chapter.Body && chapter.Title != 'Annex' && chapter.Title != 'Anhang' && chapter.Title != '_'}"
            ref="pages"
            :data-index="chapterkey"
            v-for="(chapter, chapterkey) in book.pages"
            :key="chapter._id"
          >
              <!--<pre>{{ chapter.Options }}</pre>-->
              <h1 class="chapter" v-if="chapter.Title && chapter.Options.noheader !== true">
                <span v-html="chapter.Title"/>
                <span v-if="chapter.Options.author" v-html="`<br>&nbsp;<br>${chapter.Options.author}`"/>
                <span class="jumpmark" :id="chapter._id"/>
              </h1>
              <span class="jumpmark" :id="chapter._id" v-else/>
              <div class="book-doi" v-if="chapter.Options.doi || chapter.Options.extra">
                <span v-if="chapter.Options.doi" v-html="chapter.Options.doi"/>
                <a @click="interaction" :data-sort="chapter._sort" class="extralink-folded" v-if="chapter.Options.extra">
                  &rarr; EXTRA CONTENT
                </a>
              </div>
              <template v-if="chapter.Options.size2 === true || chapter.Options.size3 === true">
                <div v-if="chapter.Attachements && chapter.Attachements.length > 0" class="page">
                  <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide v-for="(slide, slidekey) in chapter.Attachements" :data-caption="slide.Captions[3]?slide.Captions[3]:slide.Captions[0]" :key="slidekey" class="page-swiperimage-slide">
                      <div>
                        <img :src="slide.Files.Resized[2]"/>
                      </div>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                  </swiper>
                </div>
              </template>
              <div v-if="chapter.Body" class="page" :class="{'page-alphanumbering': chapter.Options.alphanumbering === true, 'page-small': chapter.Options.small === true}" v-html="chapter.Body" @click="interaction"/>
          </div>
          <h1 ref="annextitle" class="chapter annextitle">
            <span v-html="$root.t('context_annex')"/>
            <span class="jumpmark" id="__annex"/>
          </h1>
          <div ref="annex" v-if="book.meta.Bibliography || book.index.length > 0 || book.images.length > 0 || book.meta.Options.ThanksPostface || book.meta.Options.Imprint" class="book-foldable book-annex">
            <template v-if="book.meta.Bibliography">
              <span class="jumpmark jumpmark-tight" id="__bibliography"/>
              <h2>
                <span>{{$root.t('context_bibliography')}}</span>
              </h2>
              <div :class="book.meta.Options.Bibtex === true ? 'page page-small book-bibliography' : ''" v-html="book.meta.Bibliography"/>
            </template>
            <template v-if="book.index.length > 0">
              <span class="jumpmark jumpmark-tight" id="__index"/>
              <h2>
                <span>{{$root.t('context_index')}}</span>
              </h2>
              <div class="book-annex-index">
                <a :key="index.key" :id="index.id" :href="`#${index.key}`" v-for="index in book.index" v-html="index.word"/>
              </div>
            </template>
            <template v-if="book.images.length > 0">
              <span class="jumpmark jumpmark-tight" id="__credits"/>
              <h2>
                <span>{{$root.t('context_credits')}}</span>
              </h2>
              <div class="page page-small book-images">
                <template v-for="(imageChapter, chapterSort) in book.imagesSorted">
                  <p class="book-images-chapter" :key="`img-title-${chapterSort}`">
                    <span v-html="imageChapter.title"/>
                  </p>
                  <p :key="`img-${i.key}`" :id="i.image.creditid" v-for="i in imageChapter.images">
                    <span class="fnindex" :data-gf="i.image.index" :data-lf="i.image.localIndex"></span><a :href="`#${i.image.id}`" v-html="i.image.copyright"/>
                  </p>
                </template>
              </div>
            </template>
            <template v-if="book.meta.Options.ThanksPostface">
              <span class="jumpmark jumpmark-tight" id="__acknowledgments"/>
              <h2 v-if="book.meta.Options.Thanks">
                <span>{{$root.t('context_acknowledgments')}}</span>
              </h2>
              <template v-for="(section, sectionKey) in book.meta.Options.ThanksPostfaceSections">
                <span v-if="section.id" :key="`ack-jump-${sectionKey}`" class="jumpmark jumpmark-tight" :id="section.id"/>
                <h2 v-if="section.heading" :key="`ack-head-${sectionKey}`">
                  <span v-html="section.heading"/>
                </h2>
                <div v-if="section.html" :key="`ack-body-${sectionKey}`" class="page page-small page-thanks" v-html="section.html"/>
              </template>
            </template>
            <template v-if="book.meta.Options.Imprint">
              <span class="jumpmark jumpmark-tight" id="__imprint"/>
              <h2>
                <span>{{$root.t('context_imprint')}}</span>
              </h2>
              <div class="page page-small book-imprint" v-html="`${$root.project == 'GTA' ? book.meta.Options.About : ''}${book.meta.Options.Imprint}`"/>
            </template>
          </div>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div class="book-footnote" :key="`fn-${footnote.index}`" v-if="footnote.top" :style="{'top': `${footnote.top}px`}">
          <div @click="interaction" v-html="linkifyContent(footnote.content)"/>
        </div>
      </transition>
      <template v-if="!footnote.top">
        <transition v-for="extra in extradata" name="fade" v-bind:key="`extra-${extra.id}`" mode="out-in">
          <div class="book-footnote" :key="`extra-${extra.id}`" v-if="extra.top" :style="{'top': `${extra.top}px`}">
            <a @click="interaction" :data-sort="extra.sort" :data-id="extra.id" class="extralink-folded" v-html="extra.text"/>
          </div>
        </transition>
      </template>
      <div class="book-stickypic" :style="{'--max-images': stickydata.length, '--captions-height': stickyCaptionsHeight}" v-if="stickydata.length > 0 && stickydata[0].small">
        <div class="position">
          <div :id="`thumb-${stickyImage.id}`" v-for="(stickyImage, cnt) in stickydata" v-bind:key="`img-${stickyImage.id}-${cnt}`">
            <transition name="fade-fast" appear>
              <img :src="stickyImage.small" @click="openPopup(stickyImage, false)">
            </transition>
            <transition name="fade-fast" appear>
              <a v-if="stickyImage.copyright" ref="stickycaptions" :href="`#${stickyImage.creditid}`"><span :data-li="stickyImage.localindex" :data-gi="stickyImage.index"/><span v-html="stickyImage.caption"/>
              </a>
              <p v-else ref="stickycaptions"><span :data-li="stickyImage.localindex" :data-gi="stickyImage.index"/><span v-html="stickyImage.caption"/>
              </p>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <Context
    :active="currentHead"
    :title="book.meta.Name"
    :author="book.meta.Options.Author"
    :toc="book.toc"
    :bibliography="book.meta.Bibliography"
    :acknowledgments="book.meta.Options.ThanksPostface"
    :acknowledgmentsToc="book.meta.Options.ThanksPostfaceToc"
    :images="book.images.length > 0"
    :imprint="book.meta.Options.Imprint"
    :index="book.index.length > 0"
    :meta="book.meta"
    :hasParts="book.hasParts"
    :citation="book.data.Citation"
    :doi="book.data.DoiLink"
    :scrolled="contentScrolled"
    :annexPDF="
        (book.data && book.data.AnnexPdfLink)
          ? book.data.AnnexPdfLink
          : ((book.data && book.data.AnnexPDF && book.data.AnnexPDF[0])
            ? book.data.AnnexPDF[0].Original
            : false)"
    />
    <Extra v-if="book.meta.Options.extra && book.extra" v-bind:book="book"/>
    <transition name="fade">
      <div class="book-scrolldown" v-if="$root.lastScrollTop === 0">&darr;</div>
    </transition>
  </div>
</template>

<script>

import Context from '../components/Context.vue'
import Extra from '../components/Extra.vue'
import Toc from '../components/Toc.vue'
import Title from '../components/Title.vue'
import Overlay from '../components/Overlay.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { lazyLoadDirective } from '@/directives/lazyLoad'

const percRound = 1

export default {
  directives: {
    'lazy-load': lazyLoadDirective
  },
  name: 'Book',
  components: {
    Toc,
    Title,
    Extra,
    Context,
    Swiper,
    SwiperSlide,
    Overlay
  },
  data () {
    return {
      book: false,
      maxRead: false,
      currentHead: false,
      jumpmarks: [],
      currentPageIndex: false,
      contentScrolled: false,
      scrolled: false,
      debounce: null,
      stickydata: [],
      extradata: [],
      currentCaptions: {},
      footnote: {
        top: false,
        index: false,
        content: ''
      },
      sticker: {
        left: Math.random(),
        top: Math.random()
      },
      swiperOptions: {
        keyboard: true,
        spaceBetween: 20,
        pagination: {
          type: 'fraction',
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          transitionStart: function () {
            this.$el[0].scrollIntoView(
              {
                behavior: 'smooth',
                block: 'start'
              }
            )
            var caption = this.slides[this.activeIndex].dataset.caption
            this.$el[0].lastChild.innerHTML = caption
          }
        }
      },
      overlaySource: false,
      overlaySrcset: false,
      overlayShowNext: false,
      overlayCaption: '',
      overlayWidth: 0,
      overlayHeight: 0
    }
  },
  computed: {
    stickyCaptionsHeight () {
      const current = this.currentCaptions
      let totalHeight = 0
      if (current && current.length) {
        current.forEach(ref => {
          if (ref && ref.clientHeight) {
            totalHeight += ref.clientHeight
          }
        })
      }
      return `${totalHeight}px`
    },
    progress () {
      try {
        if (this.maxRead && this.book.meta.Paragraphs) {
          return `${(percRound * Math.round((100 / percRound) / (this.book.meta.Paragraphs * 1) * this.maxRead))}&nbsp;%`
        } else {
          return '0&nbsp;%'
        }
      } catch (error) {
        console.warn(error)
        return '0&nbsp;%'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    to.meta.extra = to.meta.extra === undefined || to.meta.extra === false
      ? !!to.params.extraBook
      : true
    next()
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.extraBook && +from.params.bookId === +to.params.bookId) {
      to.meta.extra = true
      this.$root.$emit('extra-opened', {...to.params, visible: true})
    } else {
      to.meta.extra = false
      if (from.params.extraBook && !to.params.extraBook) {
        this.$root.$emit('extra-opened', {visible: false})
      }
    }
    next()
  },
  watch: {
    'maxRead': function (_new, _old) {
      if (_new !== _old && this.maxRead !== false) {
        if (this.debounce) {
          clearTimeout(this.debounce)
          this.debounce = null
        }
        this.debounce = setTimeout(() => {
          window.requestAnimationFrame(() => {
            window.history.replaceState(null, null, `#p_${this.maxRead}`)
          })
        }, 250)
      }
    }
  },
  beforeDestroy () {
    this.$root.$off('extra-opened', this.onExtraOpened)
    this.$root.$off('context-opened', this.onContextOpened)
    this.$root.$off('navigation-opened', this.onNavigationOpened)
    this.$root.$off('window:scroll', this.onScrollAction)
    this.$root.$off('window:resize', this.onResizeAction)
    this.$root.$off('scroll-to', this.onScrollToAction)
    this.$root.$off('overlay-opened', this.onOverlayAction)
    this.$root.$off('overlay-close', this.onOverlayCloseAction)

    if (this.observers.length > 0) {
      this.observers.forEach(observer => {
        if (observer.o && observer.i && observer.i.length > 0) {
          observer.i.forEach(i => {
            try {
              observer.o.unobserve(i)
            } catch (err) {
              console.warn('could not unobserve')
            }
          })
          try {
            observer.o.disconnect()
          } catch (err) {
            console.warn('could not disconnect observer')
          }
        }
      })
    }
  },
  mounted () {
    if (this.$route.params.bookId) {
      this.init(this.$route.params.bookId)
    }
    this.onContextOpened = (e) => {
      if (e === true) {
        this.closeOverlay()
        this.closeFootnote()
      }
    }
    this.onNavigationOpened = e => {
      if (e === true) {
        this.closeOverlay()
        this.closeFootnote()
      }
    }
    this.onExtraOpened = e => {
      this.closeOverlay()
      this.closeFootnote()
    }
    this.onScrollAction = e => {
      if (this.overlaySource) {
        this.closeOverlay()
      }
      if (document.body.clientWidth < 1280 && this.footnote.scrollTop !== false & Math.abs(this.footnote.scrollTop - this.$root.lastScrollTop) > 150) {
        this.closeFootnote()
      }
    }
    this.onResizeAction = e => {
      this.resizeJumpMarks()
    }
    this.onScrollToAction = (data) => {
      this.$nextTick(() => {
        try {
          if (data.element) {
            data.element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
            console.log('scroll into view...')
          } else {
            window.location.hash = data.hash.replace('#', '')
            console.log('hash jump...')
          }
        } catch (err) {
          window.location.href = data.hash
          console.log('href jump...')
        }
      })
    }

    this.onOverlayAction = (data) => {
      this.openPopup(data)
    }
    this.onOverlayCloseAction = (data) => {
      this.closeOverlay()
    }
    this.$root.$on('extra-opened', this.onExtraOpened)
    this.$root.$on('context-opened', this.onContextOpened)
    this.$root.$on('navigation-opened', this.onNavigationOpened)
    this.$root.$on('window:scroll', this.onScrollAction)
    this.$root.$on('window:resize', this.onResizeAction)
    this.$root.$on('scroll-to', this.onScrollToAction)
    this.$root.$on('overlay-opened', this.onOverlayAction)
    this.$root.$on('overlay-close', this.onOverlayCloseAction)
  },
  updated: function () {
    if (this.$route.meta.extra !== true) {
      setTimeout(() => {
        if (this.$root.init === false) {
          this.$root.init = true
        }
      }, 3000)
    } else {
      this.$root.init = true
    }
  },
  methods: {
    _linkifyContent (content) {
      if (content.match(/href/)) {
        return content
      }
      const urlRegex = /(\bhttps?:\/\/[^\s<]+)/gi
      return content.replace(urlRegex, (url) => {
        return `<a href="${url}" class="footnote-external-link" data-url="${url}">${url}</a>`
      })
    },
    linkifyContent (content) {
      if (content.match(/href/)) {
        return content
      }
      const urlRegex = /(\bhttps?:\/\/[^\s<]+)/gi
      return content.replace(urlRegex, (match) => {
        let url = match
        let trail = ''

        // 1. Strip common trailing punctuation
        const punct = url.match(/[.,;:!?'"]+$/)
        if (punct) {
          trail = punct[0]
          url = url.slice(0, -trail.length)
        }

        // 2. Strip unbalanced closing brackets (so Wikipedia-style
        //    URLs like .../Foo_(bar) stay intact, but a stray `)`
        //    after the URL doesn't get pulled in)
        const pairs = { ')': '(', ']': '[', '}': '{' }
        while (pairs[url.slice(-1)]) {
          const close = url.slice(-1)
          const open = pairs[close]
          const opens = (url.match(new RegExp('\\' + open, 'g')) || []).length
          const closes = (url.match(new RegExp('\\' + close, 'g')) || []).length
          if (closes > opens) {
            trail = close + trail
            url = url.slice(0, -1)
          } else {
            break
          }
        }

        return `<a href="${url}" class="footnote-external-link" data-url="${url}">${url}</a>${trail}`
      })
    },
    /* Splits a html snippet at its h2 headings into sections, so the headings
     * can be rendered as siblings of the content blocks instead of sitting
     * inside of them (where they would be trapped in the columns of a page).
     * Every heading gets a jumpmark in front of it, just like the hardcoded
     * annex headings, so it is observed and can be scrolled to.
     * Returns the sections together with the matching toc entries
     */
    splitHeadings (html, prefix) {
      const sections = []
      const toc = []
      if (!html) {
        return {sections: sections, toc: toc}
      }
      try {
        const container = document.createElement('div')
        container.innerHTML = html
        let current = {id: false, heading: false, body: document.createElement('div')}
        const push = () => {
          if (current.heading !== false || current.body.innerHTML.trim() !== '') {
            sections.push({
              id: current.id,
              heading: current.heading,
              html: current.body.innerHTML
            })
          }
        }
        Array.from(container.childNodes).forEach(node => {
          if (node.nodeName === 'H2') {
            push()
            const id = `${prefix}_${toc.length}`
            toc.push({id: `#${id}`, text: node.innerHTML})
            current = {id: id, heading: node.innerHTML, body: document.createElement('div')}
          } else {
            current.body.appendChild(node)
          }
        })
        push()
        return {sections: sections, toc: toc}
      } catch (err) {
        console.warn(err)
        return {sections: [{id: false, heading: false, html: html}], toc: toc}
      }
    },
    getContributionTitle (id) {
      try {
        return this.book.pages.filter(b => +b._rawId === +id)[0].Title
      } catch (e) {
        return ''
      }
    },
    getContributionSort (id) {
      try {
        return this.book.pages.filter(b => +b._rawId === +id)[0]._sort
      } catch (e) {
        return ''
      }
    },
    closeOverlay () {
      this.overlaySource = false
      this.overlayWidth = 0
      this.overlayHeight = 0
      this.overlaySrcset = false
      this.overlayCaption = ''
      this.overlayShowNext = false
    },
    resizeJumpMarks () {
      const space = window.innerHeight / 2
      this.jumpmarks = this.jumpmarks.sort((a, b) => a.getBoundingClientRect().y > b.getBoundingClientRect().y)
      this.jumpmarks.forEach((p, pk) => {
        if (pk < this.jumpmarks.length - 1) {
          let height = (this.jumpmarks[ pk + 1 ].getBoundingClientRect().y - p.getBoundingClientRect().y) - space
          if (height < 0) {
            height = (this.jumpmarks[ pk + 1 ].getBoundingClientRect().y - p.getBoundingClientRect().y) - 10
          }
          if (height > 0 && !p.classList.contains('jumpmark-fixed')) {
            p.style.height = `${height}px`
          }
        }
      })
    },
    toTop () {
      window.scrollTo(0, 0)
    },
    async init (id) {
      this.observers = []
      this.jumpmarks = []
      this.book = false
      this.maxRead = false
      this.currentHead = false
      this.currentPageIndex = false
      this.debounce = null
      this.footnote = {
        top: false,
        index: false,
        content: '',
        scrollTop: false
      }
      try {
        this.book = (await this.$http.get(`/book/${id}`)).data
        this.$root.extra = this.book.meta.Options.extra
        console.log(`📕 Loading Book`, this.book)
        try {
          this.book.meta.Options.ThanksPostface = this.book.meta.Options.Thanks
          if (this.book.meta.Options.PostfaceTitle) {
            this.book.meta.Options.ThanksPostface += `<p class="page-thanks-subtitle" style="break-before: column;">${this.book.meta.Options.PostfaceTitle}</p>`
          }
          if (this.book.meta.Options.Postface) {
            this.book.meta.Options.ThanksPostface += this.book.meta.Options.Postface
          }
          const acknowledgments = this.splitHeadings(this.book.meta.Options.ThanksPostface, '__acknowledgments')
          this.book.meta.Options.ThanksPostfaceSections = acknowledgments.sections
          this.book.meta.Options.ThanksPostfaceToc = acknowledgments.toc
          if (this.book.images && Array.isArray(this.book.images)) {
            this.book.imagesSorted = []
            for (const key in this.book.images) {
              const image = this.book.images[key]
              const cId = image.contributionId
              const cT = this.getContributionTitle(cId)
              const cS = this.getContributionSort(cId)
              this.book.imagesSorted[cS] = this.book.imagesSorted[cS] || {
                title: cT,
                images: []
              }
              if (image.copyright) {
                this.book.imagesSorted[cS].images.push({
                  image: image,
                  key: key
                })
              }
            }
            this.book.imagesSorted = this.book.imagesSorted.filter(i => i.images.length > 0)
            console.log(`🖼️ Parsed images`, this.book.imagesSorted)
          }
        } catch (e) {
          console.warn(e)
        }
      } catch (err) {
        console.warn(err)
        this.$root.stopLoading()
        this.$router.push('/404')
        return
      }
      this.$root.applyMeta(
        `${this.$root.t('menu_brand')} - ${this.book.meta.Options.InsideTitle}`,
        this.book.meta.Options.Blurb,
        this.book.meta.Options.CoverAsset && this.book.meta.Options.CoverAsset.Files ? this.book.meta.Options.CoverAsset.Files.Resized[2] : false
      )
      if (this.book.meta.Options.Language === 'german') {
        this.$root.language = 0
      } else {
        this.$root.language = 1
      }
      if (this.book.meta.Options.CoverColor) {
        this.$root.color = this.book.meta.Options.CoverColor
      } else {
        this.$root.color = '128,128,128'
      }
      if (this.book.meta.Options.TextColor) {
        this.$root.textColor = this.book.meta.Options.TextColor
      } else {
        this.$root.textColor = '255,255,255'
      }
      this.$nextTick(() => {
        try {
          if (this.$route.meta.extra === true) {
            this.$root.$emit('extra-opened', {...this.$route.params, visible: true})
          }
          if (window.location.hash) {
            let e = document.getElementById(window.location.hash.replace('#', ''))
            if (e) {
              e.scrollIntoView()
              // window.scrollBy(0, -(window.innerHeight * 0.25))
            }
          }
          this.$refs.pages.forEach(page => {
            const images = page.querySelectorAll('img[v-lazy-load]')
            images.forEach(image => {
              const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.1
              }
              const iObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    const img = entry.target
                    if (img) {
                      img.src = img.dataset.src
                      observer.unobserve(entry.target)
                      observer.disconnect()
                    }
                  }
                })
              }, options)
              iObserver.observe(image)
            })

            /* Extra Observer
             * Closing Images
             */
            let extraobserver = new IntersectionObserver(
              (entries) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    let text = false
                    try {
                      text = this.book.extra.filter(a => +a._id === +entry.target.dataset.id)[0].Title || ''
                    } catch (error) {
                      // text = `${entry.target.dataset.id} Missing`
                      text = '&nbsp;'
                    }
                    this.extradata.push(
                      {
                        id: entry.target.dataset.id,
                        sort: entry.target.dataset.sort,
                        text: text,
                        top: this.calculateTopElement(entry.target) + entry.target.offsetTop
                      }
                    )
                    this.closeFootnote()
                  } else {
                    var index = this.extradata.findIndex(obj => obj.id === entry.target.dataset.id)
                    if (index !== -1) {
                      this.extradata.splice(index, 1)
                    }
                  }
                })
              },
              {
                rootMargin: '-25% 0px',
                threshold: 0
              })
            page.querySelectorAll('.extralink').forEach(p => { extraobserver.observe(p) })
            this.observers.push({
              o: extraobserver,
              i: page.querySelectorAll('.extralink')
            })
            /* IMAGE OBSERVER
             * Closing Images
             */
            let imageobserver = new IntersectionObserver(
              (entries) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    if (entry.target.classList.contains('attachement-wide')) {
                      entry.target.classList.add('attachement-wide-visible')
                    } else {
                      this.stickydata.push(entry.target.dataset)
                      this.$nextTick(() => {
                        this.currentCaptions = this.$refs.stickycaptions
                      })
                    }
                  } else {
                    var index = this.stickydata.findIndex(obj => obj === entry.target.dataset)
                    if (index !== -1) {
                      this.stickydata.splice(index, 1)
                      this.$nextTick(() => {
                        this.currentCaptions = this.$refs.stickycaptions
                      })
                    }
                  }
                })
                if (this.stickydata.length > 0) {
                  this.stickydata.sort((a, b) => a.index - b.index)
                }
              },
              {
                rootMargin: '-10% 0px -10% 0px',
                threshold: 0
              })
            page.querySelectorAll('.attachement, .attachement-wide').forEach(p => { imageobserver.observe(p) })
            this.observers.push({
              o: imageobserver,
              i: page.querySelectorAll('.attachement, .attachement-wide')
            })
            /* PARAGRAPH OBSERVER
             * Checking for scrolled paragraph
             */
            let observer = new IntersectionObserver(
              (entries) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting === true &&
                    (((this.maxRead === false || this.$root.scrolldirection === 'down') && entry.target.dataset.count * 1 >= this.maxRead) ||
                    (this.$root.scrolldirection === 'up' && entry.intersectionRatio > 0 && entry.target.dataset.count * 1 <= this.maxRead))
                  ) {
                    this.maxRead = entry.target.dataset.count * 1
                  }
                })
              },
              {
                rootMargin: '-40% 0px -40% 0px',
                threshold: 0
              })
            page.querySelectorAll('.countable').forEach(p => { observer.observe(p) })
            this.observers.push({
              o: observer,
              i: page.querySelectorAll('.countable')
            })
            /* JUMPMARK OBSERVER
             * Checking for visible jumpmarks, which are added to h2, h2 or other sections
             */
            let headobserver = new IntersectionObserver(
              (entries) => {
                const check = (entry) => {
                  if (entry.isIntersecting === true && (entry.target.parentNode.nodeName === 'H1' || entry.target.parentNode.nodeName === 'H2' || entry.target.classList.contains('jumpmark-tight'))) {
                    this.currentHead = `#${entry.target.id}`
                  }
                }
                if (this.$root.scrolldirection === 'up') {
                  for (let index = entries.length - 1; index >= 0; index--) {
                    check(entries[index])
                  }
                } else {
                  entries.forEach(entry => {
                    check(entry)
                  })
                }
              },
              {rootMargin: '-40% 0px -40% 0px'})
            page.querySelectorAll('.jumpmark').forEach(p => { headobserver.observe(p) })
            if (this.$refs.annex) {
              this.$refs.annex.querySelectorAll('.jumpmark').forEach(p => {
                headobserver.observe(p)
              })
            }
            if (this.$refs.annextitle) {
              this.$refs.annextitle.querySelectorAll('.jumpmark').forEach(p => {
                headobserver.observe(p)
              })
            }
            this.observers.push({
              o: headobserver,
              i: [
                ...page.querySelectorAll('.jumpmark'),
                ...(this.$refs.annex ? this.$refs.annex.querySelectorAll('.jumpmark') : []),
                ...(this.$refs.annextitle ? this.$refs.annextitle.querySelectorAll('.jumpmark') : [])
              ]
            })
            /* PAGE OBSERVER
             * Checking for visibility of page
             */
            let pageobserver = new IntersectionObserver(
              (entries) => {
                entries.forEach(entry => {
                  if (entry.isIntersecting) {
                    let _i = entry.target.dataset.index * 1
                    while (_i >= 0 && this.book.pages[_i].Title === '') {
                      _i--
                    }
                    this.currentPageIndex = _i
                  }
                })
              },
              {rootMargin: '0px 0px 0px 0px'})
            pageobserver.observe(page)
            this.observers.push({
              o: pageobserver,
              i: [page]
            })
          })
          document.querySelectorAll('.jumpmark').forEach(p => {
            this.jumpmarks.push(p)
          })
          this.resizeJumpMarks()
        } catch (err) {
          console.warn(err, this.$refs.pages)
        }
        let pageobserverTotal = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              this.contentScrolled = entry.isIntersecting
            })
          },
          {rootMargin: '0% 0px -100% 0px'})
        pageobserverTotal.observe(this.$refs.pageContainer)
        this.observers.push({
          o: pageobserverTotal,
          i: [this.$refs.pageContainer]
        })
      })
    },
    closeFootnote () {
      if (this.footnote.mark) {
        this.footnote.mark.classList.toggle('active', false)
        this.footnote.mark = false
        this.footnote.index = false
        this.$root.$emit('context-opened', false)
        this.$root.$emit('navigation-opened', false)
      }
      this.footnote.top = false
      this.footnote.scrollTop = false
    },
    calculateTopElement (element) {
      return element.closest('.book-text').offsetTop +
        (this.$refs.header ? this.$refs.header.clientHeight : 0) +
        (this.$refs.titleComponent.$refs.cover ? this.$refs.titleComponent.$refs.cover.clientHeight : 0) +
        (this.$refs.titleComponent.$refs.title ? this.$refs.titleComponent.$refs.title.clientHeight : 0) +
        (this.$refs.tocComponent.$refs.toc ? this.$refs.tocComponent.$refs.toc.clientHeight : 0)
    },
    interaction (event) {
      if (event.target.nodeName === 'SPAN' && (event.target.classList.contains('imageref-local') || event.target.classList.contains('imageref-global')) && event.target.parentNode.nodeName === 'A' && event.target.parentNode.classList.contains('imageref')) {
        event.preventDefault()
        event.stopPropagation()
        this.openPopup(event.target.parentNode.dataset, true)
        return false
      }
      if (event.currentTarget.nodeName === 'A' && (event.currentTarget.classList.contains('extralink') || event.currentTarget.classList.contains('extralink-folded'))) {
        event.stopPropagation()
        this.$router.push(`/${this.book.meta.Id}/${this.book.meta.Stub}/extra/${event.currentTarget.dataset.sort}${event.currentTarget.dataset.id ? `/${event.currentTarget.dataset.id}` : ''}`)
        return false
      }
      if (event.target.nodeName === 'A' && (event.target.classList.contains('extralink') || event.target.classList.contains('extralink-folded'))) {
        event.stopPropagation()
        this.$router.push(`/${this.book.meta.Id}/${this.book.meta.Stub}/extra/${event.target.dataset.sort}${event.target.dataset.id ? `/${event.target.dataset.id}` : ''}`)
        return false
      }
      if (event.target.nodeName === 'A' && event.target.classList.contains('jumpbibliography')) {
        event.stopPropagation()
        setTimeout((e) => {
          this.$refs.bibliography.querySelectorAll('.csl-entry-marker').forEach(p => {
            p.classList.toggle('csl-entry-marker-active', false)
          })
          this.$refs.bibliography.querySelector(event.target.hash).classList.toggle('csl-entry-marker-active', true)
          location.href = event.target.hash
          history.pushState(null, null, event.target.hash)
        }, 10)
        return false
      }
      if (event.target.nodeName === 'A' && event.target.classList.contains('footnote-external-link') && event.target.getAttribute('data-url')) {
        event.preventDefault()
        event.stopPropagation()
        const url = event.target.getAttribute('data-url')
        window.open(url, '_blank')
        return false
      }
      if (event.target.nodeName === 'FOOTNOTE') {
        try {
          if (this.footnote.mark) {
            this.footnote.mark.classList.toggle('active', false)
          }
        } catch (err) {
          console.warn(err)
        }
        if (this.footnote.index === event.target.dataset.index) {
          this.closeFootnote()
        } else {
          this.footnote.top = this.calculateTopElement(event.target) + event.target.offsetTop - event.target.clientHeight
          this.footnote.index = event.target.dataset.index
          this.footnote.content = this.book.footnotes[event.target.dataset.index]
          this.footnote.mark = event.target
          this.footnote.scrollTop = this.$root.lastScrollTop
          this.footnote.mark.classList.toggle('active', true)
        }
      }
      if (event.target.nodeName === 'IMG') {
        let _parent = event.target.closest('.attachement-margin')
        if (_parent.dataset.large) {
          this.$set(this, 'overlaySource', _parent.dataset.large)
          this.$set(this, 'overlayWidth', _parent.dataset.width)
          this.$set(this, 'overlayHeight', _parent.dataset.height)
          this.$set(this, 'overlayCaption', false)
          this.$set(this, 'overlayShowNext', false)
        }
      }
    },
    openPopup (dataset, captions) {
      console.log(dataset)
      captions = captions == null ? true : captions
      this.$set(this, 'overlaySource', dataset.large)
      this.$set(this, 'overlayWidth', dataset.width)
      this.$set(this, 'overlayHeight', dataset.height)
      this.$set(this, 'overlaySrcset', dataset.srcset || false)
      this.$set(this, 'overlayShowNext', dataset.showNext || false)
      if (captions) {
        this.$set(this, 'overlayCaption', dataset.caption || false)
      } else {
        this.$set(this, 'overlayCaption', false)
      }
    },
    closeTray () {
      this.$root.$emit('context-opened', false)
      this.$root.$emit('navigation-opened', false)
      this.$root.overlay = false
    }
  }
}
</script>

<style lang="scss">
    @import '../main';
    .book {
      &-largesize {
        --titlefontsize: 5.6vw;
        @media only screen and (orientation: portrait) {
            --titlefontsize: calc(5 * var(--svh-unit));
        }
        @include sm() {
          @media only screen and (orientation: portrait) {
              --titlefontsize: calc(4 * var(--svh-unit));
          }
        }
      }
      &-anthology {
        footnote:after {
          content: attr(data-lf) !important;
        }
        .fnindex:after {
          content: attr(data-lf) !important;
        }
        @include sd() {
          .attachement > div > div > a > span:before,
          .attachement > div > div > p > span:before {
            content: attr(data-li) !important;
          }
        }
        .book-stickypic > div > div > a > span:first-child:before,
        .book-stickypic > div > div > p > span:first-child:before {
            content: attr(data-li) !important;
        }
        .book-images-chapter {
          display: block !important;
          text-align: center;
          break-after: avoid !important;
          margin-bottom: var(--padding);
          margin-top: var(--padding);
          text-indent: 0 !important;
          padding-left: 0 !important;
          &:first-of-type {
            margin-top: 0;
          }
          & + * {
            break-before: avoid !important;
          }
        }
        .imageref {
          &-local {
            display: inline !important;
          }
          &-global {
            display: none !important;
          }
        }
      }
      &-extra {
        .context {
          right: var(--menuwidth-hidden);
          @include sm() {
            right: 0px;
          }
        }
      }
      position: relative;
      /* Alternate Markdown Literature */
      &-bibliography {
        p {
          overflow-wrap: break-word;
          word-wrap: break-word;
          word-break: break-all;
          word-break: break-word;
          break-inside: avoid;
          hyphens: auto;
          text-indent: calc(-1 * var(--padding));
          margin-left: var(--padding);
          padding-bottom: 0!important;
        }
      }
      &-images {
        p {
          scroll-margin-top: calc(25 * var(--svh-unit));
          a {
            word-break: break-word;
          }
        }
        &-chapter {
          display: none;
        }
      }
      &-scrolldown {
        position: fixed;
        bottom: 0;
        padding: var(--padding-05);
        left: 50%;
        text-align: center;
        /* transform: translateX(-50%); set by book init */
        @include headerfont;
        transition: transform 0.5s ease-out;
      }
      &-foldable {
        margin: auto;
        max-width: var(--blockwidth);
        position: relative;
        &:last-child {
          border-bottom: 1px solid;
        }
        h2 {
          border-top: 1px solid;
          @include sidemenufont();
          padding: var(--padding-20) 0 var(--padding-20) 0 !important;
          position: sticky !important;
          top: calc(var(--menuwidth-hidden) - 2px);
          background: var(--paper-color);
          z-index: 1;
          text-transform: uppercase;
        }
        & > div {
          padding: 0 0 var(--padding) 0 !important;
        }
        .page-small {
          @include columns;
        }
      }
      &-text {
        max-width: var(--paperwidth);
        margin: auto;
        hyphens: auto;
        position: relative;
        @include sm() {
          text-align: left;
        }
        &-wide {
          max-width: var(--blockwidth);
          text-align: left;
        }
        .book-text-alphanumbering {

        }
      }
      &-header {
        position: sticky;
        background: var(--paper-color);
        z-index: 11;
        top: 0px;
        height: var(--menuwidth-hidden);
        text-transform: uppercase;
        @include headerfont;
        @include flex-vertical-center;
        flex-direction: row;
        justify-content: space-between;
        padding: 0 var(--menuwidth-right) 0 var(--menuwidth-left);
        transform: translateZ(0);
        & > * {
          transition: opacity 0.5s linear;
        }
        a {
          cursor: pointer;
        }
        &-hidden {
          & > * {
            opacity: 0;
          }
        }
        &-left, &-right, &-center {
          @include flex-vertical-center;
          overflow: hidden;
          box-sizing: border-box;
          white-space: nowrap;
          width: 100%;
          * {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            br {
              display: none;
            }
          }
        }
        &-left {
          justify-content: flex-start;
          & > a {
            min-width: 5rem;
            display: inline-block;
          }
          @include sm() {
            display: none;
          }
        }
        &-right {
          justify-content: flex-end;
          text-align: right;
          & > a {
            text-align: right;
          }
          @include sm() {
            padding-left: var(--padding) !important;
            transform: scale(120%);
            span {
              display: none;
            }
          }
        }
        &-center {
          flex-basis: var(--paperwidth);
          justify-content: space-between;
          flex-direction: row;
          box-sizing: border-box;
          .book-header-progress {
            font-feature-settings: "tnum";
            text-overflow: clip;
            overflow: visible;
            min-width: 3em;
            text-align: right;
          }
          @include sd() {
           flex-basis: auto;
           flex-grow: 2;
          }
          @include sm() {
           padding-left: var(--padding-05);
          }
        }
        &-left, &-right {
          flex-basis: calc(((100vw - var(--paperwidth)) / 2) - var(--total-menuwidth));
          padding: 0 var(--menuwidth-hidden);
          @include sd() {
            padding: 0 var(--padding);
            flex-basis: auto;
            flex-shrink: 0;
            width: auto;
          }
          @include sm() {
           padding: 0 var(--padding-05);
          }
        }
      }

      &-footnote {
        position: absolute;
        top: 0px;
        width: calc((100vw - var(--paperwidth) - var(--total-menuwidth)) / 2 );
        right: var(--menuwidth-right);
        @include smallfont;
        padding: 0 var(--menuwidth-hidden) 0 var(--padding-20);
        box-sizing: border-box;
        z-index: 100;
        a {
          word-wrap: break-word;
        }
        & > div {
            max-width: 25vw;
        }
        @include sd() {
          bottom: 0px;
          left: var(--menuwidth-left);
          right: var(--menuwidth-right);
          z-index: 100;
          top: auto !important;
          position: fixed;
          width: auto;
          max-width: none;
          padding: var(--padding) var(--menuwidth-hidden);
          background: black;
          color: white;
          & > div {
            max-width: var(--paperwidth);
            margin: auto;
          }
        }
        @include sm() {
          padding: var(--padding) var(--padding-05) calc(2*var(--menuwidth-hidden)) var(--padding-05);
        }
      }
      &-annex {
        margin-top: var(--padding-20);
        & > div {
          @include columns;
        }
        .csl-bib-body {
          @include smallfont;
          .csl-entry {
            overflow-wrap: break-word;
            word-wrap: break-word;
            word-break: break-all;
            word-break: break-word;
            break-inside: avoid;
            hyphens: auto;
            &-marker {
              position: relative;
              display: block;
              text-indent: calc(-1 * var(--padding));
              margin-left: var(--padding);
            }
            &-marker-active {
              color: red;
            }
            .nohyphen {
              hyphens: none !important;
              word-break: break-all !important;
            }
          }
        }
        .bibtex-biblio {
          @include smallfont;
          tr {
            vertical-align: top;
            margin: 0;
          }
          td {
            margin: 0;
            padding: 0px;
          }
          .bibtex-reference {
            display: none;
          }
          .bibtex-citation {
            text-indent: calc(var(--padding-15) * -1);
            padding-left: var(--padding-15)
          }
        }
        &-index {
          @include columns;
          a {
            display: block;
            @include smallfont;
          }
        }
      }
      &-wrapper {
        position: relative;
        a {
          &:active,
          &:focus {
            color: var(--context-color) !important;
            outline: none !important;
          }
        }
      }
      &-doi {
        position: absolute;
        left: 0px;
        top: var(--padding);
        padding-top: calc(25 * var(--svh-unit));
        width: calc((100vw - var(--paperwidth) - var(--padding-30) - var(--total-menuwidth)) / 2);
        max-width: calc((var(--paperwidth) / 2) + var(--menuwidth-hidden));
        transform: translateX(-100%);
        padding-left: var(--padding);
        padding-right: var(--padding);
        box-sizing: border-box;
        @include smallfont();
        @include sd() {
          position: relative;
          padding: var(--padding) 0;
          width: 100%;
          max-width: 100%;
          transform: translateY(0);
          margin-bottom: var(--padding-20);
          top: 0;
          border-top: 1px solid white;
          border-bottom: 1px solid white;
        }
        span {
          display: inline-block;
          margin-bottom: var(--padding);
        }
        strong {
          font-family: var(--font-family);
        }
        .extralink-folded {
          @include headerfont();
        }
      }
      &-paper {
        z-index: 10;
        position: relative;
        background: var(--paper-color);
        padding: 0 calc(var(--menuwidth-right) + var(--menuwidth-hidden)) 0 calc(var(--menuwidth-left) + var(--menuwidth-hidden));
        padding-bottom: var(--padding-40);
        transform: translate3d(0px, 0px, 0px);
        backface-visibility: hidden;
        @include sm() {
          padding: 0 calc(var(--menuwidth-hidden) + var(--padding-05));
        }
      }
      &-paper-content {
        position: relative;
        z-index: 1;
        h1, h2, h3, h4 {
          font-weight: bold;
          position: relative;
          hyphens: manual;
          &.chapter {
            position: relative;
            @include chapterfont;
            font-weight: 600;
            @include svh(25, 'padding-top');
            @include svh(25, 'padding-bottom');
            @include sm() {
              padding: var(--padding-30) 0;
            }
          }
        }
        h5 {
          text-align: left;
        }
        .book-no-body {
          h1, h2, h3, h4, h5 {
            &.chapter {
              padding-bottom: 0 !important;
            }
          }
        }
        h1 {
            @include mediumfont;
            text-transform: uppercase;
        }
        h2, h3 {
          text-transform: uppercase;
        }
        .jumpmark {
          display: inline-block;
          position: absolute;
          top: 0px;
          left: 0px;
          background: transparent;
          width: 1px;
          height: 20px;
          scroll-margin-top: var(--menuwidth-hidden);
          &-tight {
            position: relative;
            float: left;
            scroll-margin-top: calc(var(--menuwidth-hidden) - 2px);
          }
        }
      }
      .page {
        line-height: var(--lauftext-lineheight);
        font-size: var(--lauftext-fontsize);
        text-align: justify;
      }
      &-footnote,
      .page {
        font-family: var(--lauftext-font);
        blockquote {
          margin: 0;
          margin-left: var(--padding-40);
          @include sm() {
            margin-left: var(--padding-20);
          }
          &.rtl {
            direction: rtl;
            margin: 0;
            margin-right: var(--padding-40);
            @include sm() {
              margin-right: var(--padding-20);
            }
          }
        }
        code {
          font: inherit;
        }
        .extralink {
          display: inline-block;
          font-family: 'Extra';
          vertical-align: bottom;
          font-style: normal;
          margin-left: var(--padding-025);
          margin-right: var(--padding-025);
          &:before{content:'\002b';}
          cursor: pointer;
        }
        .extralink-folded {
          font-weight: bold;
          cursor: pointer;
          display: inline-block;
          margin-top: 5px;
          @include sm() {
            margin-top: 0px;
            &:before {
              content:'\002b';
              display: inline-block;
              font-family: 'Extra';
              vertical-align: bottom;
              font-weight: normal;
              line-height: 1;
              margin-right: var(--padding-025);
            }
          }
        }
        /*
          // MARGIN VARIANT
          .extralink {
            font-family: 'Extra';
            vertical-align: bottom;
            font-style: normal;
            &:before{content:'\002b';}
            cursor: pointer;
            display: inline-block;
            margin: none;
            width: 0px;
            overflow: hidden;
            @include sm() {
              margin-left: var(--padding-025);
              margin-right: var(--padding-025);
              display: inline-block;
              width: auto;
              overflow: hidden;
            }
          }
          .extralink-folded {
            font-weight: bold;
            cursor: pointer;
            margin-top: 5px;
            display: inline-block;
            &:before {
              content:'\002b';
              display: inline-block;
              font-family: 'Extra';
              vertical-align: bottom;
              font-weight: normal;
              line-height: 1;
              margin-right: var(--padding-025);
              transform: translateY(-1px);
            }
            @include sm() {
              margin-top: 0px;
              &:before {
                transform: translateY(0px);
              }
            }
          }
        */
        .index {
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        pre > code {
          font-size: 90%;
        }
        ul {
          margin: 0 var(--padding) 0 0;
          list-style: none;
          padding-left: var(--padding);
          li {
            text-indent: calc(-1 * var(--padding));
            padding-left: var(--padding);
            &:before {
              content: "–";
              float: left;
              width: var(--padding);
            }
          }
        }
        ol {
          list-style-type: decimal;
          margin: 0 var(--padding);
          list-style-position: outside;
        }
        &-alphanumbering {
          ol {
            list-style-type: lower-alpha;
          }
        }
        dl {
          hyphens: none;
          dt {
            font-weight: bold;
            margin-right: var(--padding-025);
            display: inline;
            float: left;
            white-space: break-spaces;
          }
          dd {
            margin-left: var(--padding);
          }
        }
        dl + div {
          text-indent: var(--padding);
        }
        .mark {
          display: inline-block;
          visibility: hidden;
          width: 0px;
          height: 0px;
          overflow: hidden;
        }
        .reference,
        .imageref {
          /*display: inline;
          @include smallfont();
          text-align: center;
          margin-right: var(--padding-025);
          padding: 0 var(--padding-025);
          border: 1px solid;
          vertical-align: middle;*/
          opacity: 0.5;
          &-local {
            display: none;
          }
          &-global {
            display: inline;
          }
        }
        footnote {
          cursor: pointer;
          position: relative;
          font-size: 55%;
          font-family: var(--font-family);
          font-weight: bold;
          display: inline;
          vertical-align: super;
          break-before: avoid;
          box-sizing: border-box;
          line-height: 0.85;
          margin-right: 5px;
          transition: color 0.125s;
          &.active {
            color: var(--link-hover-color);
          }
          @include hover() {
            color: var(--link-hover-color);
          }
          &:after {
            content: attr(data-gf);
          }
        }
        .comment {
          display: block;
          background: #FF0;
          border-radius: 0.5rem;
          padding: 0.5rem;
        }
        .latex {
          display: none;
        }
        .reference:before {
          content: "[";
        }
        .reference:after {
          content: "]";
        }
        /*
        Unconsistent with latex
        .imageref:before {
          content: "Img.";
        }*/
        .mark {
          background: transparent;
          color: black;
          &:before {
            content: "Mark ";
          }
        }
        .bibtex-cite {
        }
        &-small {
          @include columns;
          h1, h2, h3, h4 {
            column-span: all;
          }
          @include smallfont();
          p {
            padding-bottom: var(--padding-05);
            a {
              overflow-wrap: break-word;
            }
          }
          text-align: left !important;
        }
        &-thanks {
          dl {
            margin: 0;
          }
          dd {
            padding-bottom: var(--padding-05);
            break-before: avoid-column;
          }
          dt {
            break-after: avoid-column;
          }
        }
        .attachement {

          width: 0px;
          height: var(--padding);
          float: left;

          display: inline;
          // Fix afer ILAUD: remove stickyness to make them disappear quicker
          //position: sticky;
          //@include lvh(50, 'top');
          position: relative;
          top: 0px;
          opacity: 1;
          transition: opacity 0.25s linear;

          scroll-margin-top: 10vh;

          &:after {
            width: var(--padding-05);
            background: transparent;
            border-radius: 50%;
            height: var(--padding-05);
            top: var(--padding-05);
            content: "";
            position: absolute;
            background: black;
            right: var(--padding-05);
            opacity: 0;
          }
          & > div {
            display: none;
          }
          @include sd() {
            display: block;
            position: relative;
            width: 100%;
            top: auto;
            padding: var(--padding) 0;
            opacity: 1 !important;
            float: none;
            height: auto;
            & > div {
              display: block;
              position: relative;
              width: 100%;
              max-width: 100%;
              margin: auto;
              padding: 0;
              bottom: auto;
              box-sizing: border-box;
              transform: translateX(0%);
              text-align: center;
              top: 0px;
              background: var(--paper-color);

              &:after {
                display: none;
              }
              & > div {
                display: inline-table;
                text-align: left;
                right: 0px;
                & > p,
                & > a {
                  min-height: auto;
                  margin-top: var(--padding-05);
                  @include smallfont;
                  display:table-caption;
                  caption-side:bottom;
                  background: var(--paper-color);
                  position: relative;
                  padding: 0;
                  z-index: 1;
                  padding-left: var(--padding-15);
                  text-indent: calc(-1 * var(--padding-15));
                  & > span:first-child {
                    min-width: var(--padding-15);
                    display: inline-block;
                    text-indent: 0;
                    &:before {
                      content: attr(data-gi);
                    }
                  }
                  &:after {
                    display: none;
                  }
                }
              }
              img {
                margin: auto;
                width: auto;
                height: auto;
                display: block;
                @include svh(75, max-height);
                max-width: 100%;
              }
            }
          }
          & + br {
            display: none;
          }
        }
        .attachement-margin {
          cursor: pointer
        }
        .attachement-wide {
          width: calc(100vw - var(--total-menuwidth));
          transform: translateX(calc(-1 * ((100vw - var(--paperwidth) - var(--total-menuwidth)) / 2)));
          display: block;
          position: relative;
          background: var(--paper-color);
          text-align: center;
          padding: var(--padding);
          box-sizing: border-box;
          opacity: 0;
          transition: opacity 0.25s linear;
          &-visible {
            opacity: 1;
          }
          & > div {
            width: auto;
            display: inline-block;
            position: relative;
            & > div {
              display: inline-table;
              text-align: left;
              img {
                width: auto;
                height: auto;
                max-width: 100%;
                @include svh(66, 'max-height');
              }
              & > p,
              & > a {
                @include smallfont;
                display:table-caption;
                caption-side:bottom;
                background: var(--paper-color);
                position: relative;
                z-index: 1;
                display: block;
                & > span:first {
                  margin-right: var(--padding);
                }
              }
            }
          }
          @include sd() {
            display: block;
            width: 100%;
            transform: translateX(0px);
            padding: var(--padding) 0;
            opacity: 1 !important;
          }
        }
        .swiper-container {
          width: calc(100vw - (var(--total-menuwidth) + 2 * var(--menuwidth-hidden)));
          @include svh(100);
          top: 0px;
          transform: translateX(calc(-1 * ((100vw - var(--paperwidth) - var(--total-menuwidth)) / 2 - var(--menuwidth-hidden))));

          @include tb() {
            width: 100%;
            transform: translateX(0px);
          }
          display: block;
          position: relative;
          text-align: center;
          box-sizing: border-box;
          .swiper-slide {
            width: 100%;
            height: 100%;
            @include flex-vertical-center;
            text-align: center;
            & > div {
              display: inline-table;
              text-align: left;
              margin: auto;
              img {
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: calc(calc(100 * var(--svh-unit)) - (3 * var(--menuwidth-hidden)));
              }
            }
          }
          .swiper-notification {
            @include smallfont;
            opacity: 1;
            position: absolute;
            left: 0;
            bottom: var(--padding);
            z-index: 1;
            padding: 0;
            top: auto;
          }
          .swiper-pagination-fraction {
            @include smallfont;
            width: auto;
            text-align: right;
            right: 0;
            left: auto;
            bottom: var(--padding);
            display: inline-block;
          }
          .swiper-button-next,
          .swiper-button-prev {
            color: #000;
            padding: 0;
            width: auto;
            height: auto;
            padding: var(--padding);
            @include sm() {
              display: none;
            }
            &:after {
              font: inherit;
              content: "←"
            }
          }
          .swiper-button-prev {
            left: 0px;
            padding-left: 0;
          }
          .swiper-button-next {
            right: 0px;
            padding-right: 0;
            &:after {
              content: "→"
            }
          }
        }
      }
      .fnindex {
        display: none;
        &:after {
          content: attr(data-gf);
        }
      }
      .book-images {
        p {
          padding-left: var(--padding-15);
          text-indent: calc(-1 * var(--padding-15));
          break-inside: avoid;
          .fnindex {
            min-width: var(--padding-15);
            display: inline-block;
            text-indent: 0;
          }
        }
      }
      .book-imprint {
        p {
          break-inside: avoid;
        }
      }
      .book-stickypic {
        position: fixed;
        @include lvh(50, 'top');
        left: var(--menuwidth-left);
        width: calc((100vw - var(--paperwidth) - var(--total-menuwidth)) / 2);
        z-index: 100;
        @include sd() {
          display: none;
        }
        & > div {
          max-height: calc(calc(100 * var(--svh-unit)) - 2 * var(--menuwidth-hidden));
          overflow: hidden;
          position: absolute;
          max-width: calc((var(--paperwidth) / 2) + var(--menuwidth-hidden));
          padding: 0 var(--padding-20) 0 var(--menuwidth-hidden);
          box-sizing: border-box;
          top: 0px;
          right: 0px;
          text-align: right;
          width: 100%;
          transform: translateY(-50%);
          img {
            height: auto;
            width: 100%;
            object-fit: contain;
            object-position: left;
            max-height: calc(((100 * var(--svh-unit)) - 2 * var(--menuwidth-hidden) - var(--captions-height) - (var(--max-images) * var(--padding-20))) / var(--max-images));
            cursor: pointer;
          }
          & > div {
            &:not(:first-child) {
              margin-top: var(--padding)
            }
            display: table;
            text-align: left;
            right: 0px;
            width: 100%;
            & > p,
            & > a {
              @include smallfont;
              display:table-caption;
              caption-side:bottom;
              background: var(--paper-color);
              position: relative;
              padding: 0;
              z-index: 1;
              padding-left: var(--padding-15);
              padding-top: var(--padding-025);
              text-indent: calc(-1 * var(--padding-15));
              & > span:first-child {
                min-width: var(--padding-15);
                display: inline-block;
                text-indent: 0;
                &:before {
                  content: attr(data-gi);
                }
              }
            }
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/Book.vue